export enum MyCvFeatureFlags {
  MyCvHasUploadModule= 'MyCvHasUploadModule',
  MyCvHasCreateModule= 'MyCvHasCreateModule',
}
